import { generateCsv, download } from 'export-to-csv';
import { Box } from '@mui/material';
import CsvConfig from './CsvConfig';

export default class RptActivationDataExport {

  constructor() {
    if (this.constructor.instance) {
        return this.constructor.instance;
      }
      this.constructor.instance = this;
}

  getVisibility(extraCols) {
    if (extraCols) {
      return  {IPAddress: true,  ActivationType:true,  ResultCode:true,  DeactivatedBy:true,  ExtraInfo:true,  isTest:false, isActive:false, isSuccess:false } 
    }
    else {
      return { IPAddress: false, ActivationType:false, ResultCode:false, DeactivatedBy:false, ExtraInfo:false, isTest:false, isActive:false, isSuccess:false }
    }
  }

  // dataTableColumns - the definition of the columns
  dataTableColumns() {
  return(
  [
    {
      accessorKey: "CompanyName",
      header: "Company",
      filterFn: 'contains',
    },   
    {
      accessorKey: "CustomerID", 
      header: "CustomerID",
      filterFn: 'contains',
      Cell: ({ cell }) => (<Box sx={{color:'blue'}}>{cell.getValue()}</Box>),      
      muiTableBodyCellProps: ({ cell, column, table }) => ({
        onDoubleClick: (event) => {
          console.info(event.target.innerText);
          window.open("https://license.netlibsecurity.com/solo/authors/CustomerDetails.aspx?CustomerID="+event.target.innerText, '_blank')
        },
      }),      
    },     
    {
      accessorKey: "LicenseID", 
      header: "LicenseID",
      filterFn: 'contains',
      Cell: ({ cell }) => (<Box sx={{color:'blue'}}>{cell.getValue()}</Box>),          
      muiTableBodyCellProps: ({ cell, column, table }) => ({
        onDoubleClick: (event) => {
          console.info(event.target.innerText);
          window.open("https://license.netlibsecurity.com/solo/authors/orderdetail.asp?Action=View&LicenseID="+event.target.innerText, '_blank')
        },
      }),        
    },
    {
      accessorKey: "ProductName", 
      header: "ProductName",
      filterFn: 'contains',
    },
    {
      accessorKey: "OptionName", 
      header: "OptionName",
      filterFn: 'contains',
    },
    {
      accessorKey: "ActivationDate", 
      header: "ActivationDate",
      filterVariant: 'date-range',
      accessorFn: (originalRow) => new Date(originalRow.ActivationDate),
      Cell: ({ cell }) => (cell.getValue() === '' ? '' : cell.getValue().toLocaleString('sv-SE')),
    },
    {
      accessorKey: "InstallationName", 
      header: "InstallationName",
      filterFn: 'contains',
    },
    {
      accessorKey: "InstallationID", 
      header: "InstallationID",
      filterFn: 'contains',
      Cell: ({ cell }) => (<Box sx={{color:'blue'}}>{cell.getValue()}</Box>),
      muiTableBodyCellProps: ({ cell, column, table }) => ({
        onDoubleClick: (event) => {
          console.info(event.target.innerText);
          window.open("https://license.netlibsecurity.com/solo/authors/ActivationDetail.aspx?InstallationID="+event.target.innerText, '_blank')
        },
      }),
    },
    {
      accessorKey: "ActivationType", 
      header: "ActivationType",
      filterFn: 'contains',
    },
    {
      accessorKey: "IPAddress", 
      header: "IPAddress",
      filterFn: 'contains',
    },
    {
      accessorKey: "ResultCode", 
      header: "ResultCode",
      filterFn: 'contains',
    },
    {
      accessorKey: "DeactivatedDate",
      header: "DeactivatedDate",
      filterVariant: 'date-range',
      accessorFn: (originalRow) => (originalRow === undefined || originalRow.DeactivatedDate === undefined || originalRow.DeactivatedDate[0] === "" ? "" : new Date(originalRow.DeactivatedDate)),
      Cell: ({ cell }) => (cell.getValue() === '' ? '' : cell.getValue().toLocaleString('sv-SE')),
    },    
    {
      accessorKey: "DeactivatedBy", 
      header: "DeactivatedBy",
      filterFn: 'contains',
    },
    {
      accessorKey: "ExtraInfo", 
      header: "ExtraInfo",
      filterFn: 'contains',
    },    
    {
      header: 'Success',
      accessorFn: (originalRow) => (originalRow === undefined || originalRow.ResultCode === undefined ? 'false' : (originalRow.ResultCode[0] === "0" ? 'true' : 'false')), //must be strings
      id: 'isSuccess',
      filterVariant: 'checkbox',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? 'Success' : 'Failure',
      size: 170,
    },    
    {
      header: 'Status',
      accessorFn: (originalRow) => (originalRow === undefined || originalRow.DeactivatedDate === undefined ? 'false' : (originalRow.DeactivatedDate[0] === "" ? 'true' : 'false')), //must be strings
      id: 'isActive',
      filterVariant: 'checkbox',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? 'Active' : 'Inactive',
      size: 170,
    },
    {
      header: 'Test',
      accessorFn: (originalRow) => (originalRow === undefined || originalRow.CompanyName === undefined ? 'false' : (originalRow.CompanyName[0].includes("TEST") ? 'true' : 'false')), //must be strings
      id: 'isTest',
      filterVariant: 'checkbox',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? 'Test' : 'Prod',
      size: 170,
    }
                     
  ]
  )

  }

/*
Source (hard coded with “License Portal”
Company
CustomerID
LicenseID
ProductDescr (concatenate ProductName,space,OptionName)
Activation Date (present as date/time - remove T as in the display)
InstallationName
InstallationID
DeactivatedDate (only if Hide Deactivate not selected)
If Add Details selected, add columns
ActivationType
IPAddress
ResultCode
DeactivatedDate
*/

 // handleExportRows - sorted and selected data
 handleExportRows = (rows, extraCols) => {

  if (rows === undefined)
    return;

    const CSVConfig = new CsvConfig();
    const csvConfig = CSVConfig.makeCsvConfig();
    if (!extraCols) {
      var rowData;
      rowData = rows.map(
        function(row) {
          return { 
            "Source": "License Portal",
            "CompanyName" : row.original.CompanyName[0], 
            "CustomerID" : row.original.CustomerID[0], 
            "LicenseID" : row.original.LicenseID[0], 
            "ProductDescr" : row.original.ProductName + " " + row.original.OptionName, 
            "ActivationDate" : row.original.ActivationDate[0], 
            "InstallationName" : row.original.InstallationName[0], 
            "InstallationID" : row.original.InstallationID[0], 
            "DeactivatedDate" : row.original.DeactivatedDate[0],                      
          }
        }
      )
    }
    else {
      rowData = rows.map(
        function(row) {
          return { 
            "Source": "License Portal",
            "CompanyName" : row.original.CompanyName[0], 
            "CustomerID" : row.original.CustomerID[0], 
            "LicenseID" : row.original.LicenseID[0], 
            "ProductDescr" : row.original.ProductName + " " + row.original.OptionName, 
            "ActivationDate" : row.original.ActivationDate[0], 
            "InstallationName" : row.original.InstallationName[0], 
            "InstallationID" : row.original.InstallationID[0],             
            "ActivationType": row.original.ActivationType[0], 
            "IPAddress": row.original.IPAddress[0], 
            "ResultCode": row.original.ResultCode[0],
            "DeactivatedDate" : row.original.DeactivatedDate[0],             
            "DeactivatedBy" : row.original.DeactivatedBy[0],    
            "ExtraInfo" : row.original.ExtraInfo[0],          
          }
        }
      )
    }
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  // handleExportData - all data
  handleExportData = (rows, extraCols) => {
    if (rows === undefined)
      return;
  
    const CSVConfig = new CsvConfig();
    const csvConfig = CSVConfig.makeCsvConfig();
    if (!extraCols) {
        var rowData;
        rowData = rows.map(
          function(row) {
            return { 
              "Source": "License Portal",
              "CompanyName" : row.CompanyName[0], 
              "CustomerID" : row.CustomerID[0], 
              "LicenseID" : row.LicenseID[0], 
              "ProductDescr" : row.ProductName + " " + row.OptionName, 
              "ActivationDate" : row.ActivationDate[0], 
              "InstallationName" : row.InstallationName[0], 
              "InstallationID" : row.InstallationID[0], 
              "DeactivatedDate" : row.DeactivatedDate[0],             
            }
          }
        )
      }
      else {
        rowData = rows.map(
          function(row) {
            return { 
              "Source": "License Portal",
              "CompanyName" : row.CompanyName[0], 
              "CustomerID" : row.CustomerID[0], 
              "LicenseID" : row.LicenseID[0], 
              "ProductDescr" : row.ProductName + " " + row.OptionName, 
              "ActivationDate" : row.ActivationDate[0], 
              "InstallationName" : row.InstallationName[0], 
              "InstallationID" : row.InstallationID[0],             
              "ActivationType": row.ActivationType[0], 
              "IPAddress": row.IPAddress[0], 
              "ResultCode": row.ResultCode[0],
              "DeactivatedDate" : row.DeactivatedDate[0],     
              "DeactivatedBy" : row.DeactivatedBy[0],  
              "ExtraInfo" : row.ExtraInfo[0],       
            }
          }
        )
      }
      const csv = generateCsv(csvConfig)(rowData);
      download(csvConfig)(csv);
  };


}